var map = {
	"./bianzu.png": "0de7",
	"./bianzu_en.png": "4d4f",
	"./bianzu_es.png": "eec8",
	"./bianzu_hk.png": "732c",
	"./bianzu_pt.png": "f311",
	"./bianzu_tr.png": "502c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8b3";